export default "__VITE_ASSET__Dk$GL6$9__"